import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

/**
 * TruncatedUrl component that truncates long URLs and shows full URL in a popover on hover
 * @param {string} url - The URL to display
 * @param {number} maxLength - Maximum length before truncation (default: 50)
 * @param {string} className - Additional CSS classes
 * @param {string} target - Link target attribute (default: "_blank")
 * @param {string} rel - Link rel attribute (default: "noopener noreferrer")
 */
export function TruncatedUrl({ 
    url, 
    maxLength = 50, 
    className = "",
    target = "_blank",
    rel = "noopener noreferrer",
    ...props 
}) {
    if (!url) return null;

    const truncatedUrl = url.length > maxLength && url.substring(0, maxLength - 3) + "..." || null;
    const needsTruncation = url.length > maxLength;

    const urlContent = (
        <a 
        href={url}
        target={target}
        rel={rel}
        className={cn(
            "text-sm text-muted-foreground hover:text-primary transition-colors",
            className
        )}
        {...props}
    >
        <span className={cn(
            "inline-flex items-center gap-1 transition-colors",
            className
        )}>
            <span className="break-all">{truncatedUrl ? truncatedUrl : url}</span>
        </span>
    </a>
    );

    if (!needsTruncation) {
        return urlContent;
    }


    return (
        <TooltipProvider>
            <Tooltip delayDuration={300}>
                <TooltipTrigger asChild>
                    {urlContent}
                </TooltipTrigger>
                <TooltipContent 
                    side="bottom" 
                    align="start"
                    className="max-w-md p-3"
                >
                    <p className="text-xs font-mono break-all bg-muted/50 p-2 rounded border">
                        {url}
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
